import React from "react"
import PropTypes from "prop-types"
import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"
import StatelessDropDown from "../stateless-drop-down/index.jsx"
import createReactClass from "create-react-class"

var DropDown = createReactClass({
  propTypes: {
    className: PropTypes.string,
    collection: PropTypes.array.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    isNotValid: PropTypes.bool,
  },
  getInitialState: function () {
    return {
      value: this.props.value,
    }
  },
  render() {
    return (
      <StatelessDropDown
        {...this.props}
        value={this.state.value}
        onChange={(e, value) => {
          this.setState({ value: value })
          if (this.props.onChange) this.props.onChange(e, value)
        }}
      />
    )
  },
})

export default ValidationMixin(DropDown)
